import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [``],
})
export class PageAccessComponent implements OnInit {
    public view: string = 'login';
    public loading: boolean = false;
    public resetResult: string = '';

    public data: any = {
        email: '',
        password: ''
    };

    public signupData: any = {
        name: '',
        email: '',
        password: '',
        password_confirm: ''
    };

    public resetData: any = {
        email: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        try {
            await this.service.init();
            if (this.service.auth.check()) return location.href = this.homePath();
        } catch (e) { }
    }

    public async setView(view: string) {
        if (this.loading) return;
        if (!['login', 'signup', 'reset'].includes(view)) return;
        this.view = view;
        this.resetResult = '';
        await this.service.render();
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public validEmail(email: string) {
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email || '');
    }

    private text(value: any) {
        return String(value || '').trim();
    }

    private email(value: any) {
        return this.text(value).toLowerCase();
    }

    private response(value: any) {
        let payload = value && value.responseJSON ? value.responseJSON : value;
        if (!payload || typeof payload !== 'object') return { code: 500, data: {} };

        let code = Number(payload.code);
        if (!Number.isFinite(code)) code = 500;

        return {
            code: code,
            data: payload.data && typeof payload.data === 'object' ? payload.data : {}
        };
    }

    private async call(action: string, payload: any) {
        try {
            return this.response(await wiz.call(action, payload));
        } catch (e) {
            return { code: 500, data: { message: "요청 처리 중 오류가 발생했습니다." } };
        }
    }

    private async run(task: any) {
        if (this.loading) return null;
        this.loading = true;
        await this.service.render();
        try {
            return await task();
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    private homePath(role?: string) {
        const value = String(role || this.service.auth.session?.role || '').toLowerCase();
        if (value === 'system' || value === 'admin') return '/members';
        if (value === 'manager') return '/literature';
        if (value === 'reviewer') return '/review';
        return '/mypage';
    }

    public async login() {
        let user = {
            email: this.email(this.data.email),
            password: this.data.password || ''
        };
        this.data.email = user.email;

        if (!this.validEmail(user.email)) {
            await this.alert("올바른 이메일을 입력해주세요.");
            return;
        }
        if (!user.password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }

        let result = await this.run(async () => await this.call("login", user));
        if (!result) return;

        if (result.code == 200) {
            location.href = result.data.redirect || this.homePath(result.data.session?.role);
        } else {
            await this.alert(result.data.message || "로그인에 실패했습니다.", 'error');
        }
    }

    public async signup() {
        const payload = {
            name: this.text(this.signupData.name),
            email: this.email(this.signupData.email),
            password: this.signupData.password || '',
            password_confirm: this.signupData.password_confirm || ''
        };
        this.signupData.name = payload.name;
        this.signupData.email = payload.email;

        if (!payload.name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!this.validEmail(payload.email)) {
            await this.alert("올바른 이메일을 입력해주세요.");
            return;
        }
        if (!payload.password || payload.password.length < 8) {
            await this.alert("비밀번호는 8자 이상이어야 합니다.");
            return;
        }
        if (payload.password !== payload.password_confirm) {
            await this.alert("비밀번호 확인이 일치하지 않습니다.");
            return;
        }

        const result = await this.run(async () => await this.call("signup", payload));
        if (!result) return;

        if (result.code === 200) {
            location.href = result.data.redirect || this.homePath('viewer');
        } else {
            await this.alert(result.data.message || "회원가입에 실패했습니다.");
        }
    }

    public async resetPassword() {
        const payload = {
            email: this.email(this.resetData.email)
        };
        this.resetData.email = payload.email;
        this.resetResult = '';

        if (!this.validEmail(payload.email)) {
            await this.alert("올바른 이메일을 입력해주세요.");
            return;
        }

        const result = await this.run(async () => await this.call("reset_password", payload));
        if (!result) return;

        if (result.code === 200) {
            this.resetResult = result.data.temporary_password || '';
            await this.service.render();
        } else {
            await this.alert(result.data.message || "비밀번호 재설정에 실패했습니다.");
        }
    }
}

export default PageAccessComponent;